export const validateEmail = (email) => {
  return email?.toLowerCase().match(/^[\w%\+\-]+(\.[\w%\+\-]+)*@[\w%\+\-]+(\.[\w%\+\-]+)+$/) || false;
};